import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import Typography from '@mui/material/Typography';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/styles": { styled }, "@mui/material/Box": Box, "@mui/material/Rating": Rating, "@mui/icons-material/Favorite": FavoriteIcon, "@mui/icons-material/FavoriteBorder": FavoriteBorderIcon, "@mui/material/Typography": Typography } } });
export default ClientProvider;
